import React from 'react';
import {
    TextField,
    InputAdornment,
    FormControl,
    Select,
    MenuItem,
    SelectChangeEvent,
    Paper,
    useTheme,
    alpha
} from '@mui/material';
import { Search as SearchIcon, FilterList as FilterIcon } from '@mui/icons-material';
import { UserRole } from '../../../types/auth';

interface UserFiltersProps {
    searchQuery: string;
    onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    selectedRole: UserRole | 'all';
    onRoleChange: (event: SelectChangeEvent<UserRole | 'all'>) => void;
}

const UserFilters: React.FC<UserFiltersProps> = ({
    searchQuery,
    onSearchChange,
    selectedRole,
    onRoleChange
}) => {
    const theme = useTheme();

    return (
        <Paper
            elevation={0}
            sx={{
                p: 2,
                mb: 3,
                borderRadius: 3,
                border: `1px solid ${theme.palette.divider}`,
                display: 'flex',
                gap: 2,
                flexWrap: 'wrap',
                alignItems: 'center',
                bgcolor: alpha(theme.palette.background.paper, 0.6),
                backdropFilter: 'blur(10px)'
            }}
        >
            <TextField
                placeholder="Search users..."
                value={searchQuery}
                onChange={onSearchChange}
                size="small"
                sx={{
                    flexGrow: 1,
                    minWidth: 200,
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        bgcolor: theme.palette.background.paper
                    }
                }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon color="action" />
                        </InputAdornment>
                    ),
                }}
            />

            <FormControl size="small" sx={{ minWidth: 180 }}>
                <Select
                    value={selectedRole}
                    onChange={onRoleChange}
                    displayEmpty
                    sx={{
                        borderRadius: 2,
                        bgcolor: theme.palette.background.paper,
                        '& .MuiSelect-select': {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1
                        }
                    }}
                    startAdornment={
                        <InputAdornment position="start" sx={{ mr: 1 }}>
                            <FilterIcon fontSize="small" color="action" />
                        </InputAdornment>
                    }
                >
                    <MenuItem value="all">All Roles</MenuItem>
                    <MenuItem value="student">Students</MenuItem>
                    <MenuItem value="teacher">Teachers</MenuItem>
                    <MenuItem value="admin">Administrators</MenuItem>
                </Select>
            </FormControl>
        </Paper>
    );
};

export default UserFilters;
